module.exports = __webpack_public_path__ + "static/frontier-science-logo-a2969518f1bf121d17dcd0b5f3764ad6.svg";